/** Slot-phase card for the welcome plan tour (drag hint + skip). */
import { Box, Button, Paper, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS } from '@/features/onboarding/constants/welcomePlanTour';
import { onboardingHintCardPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';

/**
 * @param {Object} props
 * @param {'firstStep' | 'task'} props.slotDragHintKind
 * @param {() => void} props.completeSlot
 */
const OnboardingWelcomePlanTourSlot = ({ slotDragHintKind, completeSlot }) => {
  const t = useT();
  const dragHintKey =
    slotDragHintKind === 'firstStep'
      ? 'onboarding.slot.dragHintFirstStep'
      : 'onboarding.slot.dragHintTask';
  const dragHintDefault =
    slotDragHintKind === 'firstStep'
      ? 'Dit is je Volgende actie, de eerste stap van je taak. Sleep hem naar een moment in je planning.'
      : 'Sleep je taak naar een moment in je planning.';

  return (
    <Paper
      variant="outlined"
      data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.slot}
      sx={onboardingHintCardPositionSx}
      role="region"
    >
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        {t(dragHintKey, dragHintDefault)}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
        <Button variant="text" size="small" onClick={completeSlot}>
          {t('onboarding.slot.skip', 'Overslaan')}
        </Button>
        <Typography variant="caption" color="text.secondary">
          {t(
            'onboarding.slot.skipLaterHint',
            'Je kan hem later inplannen.',
          )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default OnboardingWelcomePlanTourSlot;
